import consumer from "./consumer"

consumer.subscriptions.create(
  { channel: "ChatChannel", platform: "web" },
  {
  connected() { },

  disconnected() { },

  received(data) {
    const history = document.querySelector(`[data-channel='chat-${data.id}']`)

    if (!history) return

    const pendingBubble = history.querySelector(".chat-msg--pending")
    if (pendingBubble) pendingBubble.remove()

    const answer = data.message?.answer ?? data.message
    if (!answer) return

    const bubble = this.buildAssistantBubble({
      answer,
      timestamp: data.message?.created_at,
    })

    history.appendChild(bubble)
    history.scrollTop = history.scrollHeight
  },

  buildAssistantBubble({ answer, timestamp }) {
    const bubble = document.createElement("article")
    bubble.className = "chat-msg chat-msg--assistant"

    const inner = document.createElement("div")
    inner.className = "chat-msg__inner"

    const avatarWrap = document.createElement("div")
    avatarWrap.className = "chat-msg__avatar"
    avatarWrap.innerHTML = `<img src="/assets/images/ravi/rav.jpeg" alt="Rav">`

    const bubbleEl = document.createElement("div")
    bubbleEl.className = "chat-msg__bubble"

    const content = document.createElement("div")
    content.className = "chat-msg__content"
    content.appendChild(this.formattedText(answer))

    bubbleEl.appendChild(content)
    inner.appendChild(avatarWrap)
    inner.appendChild(bubbleEl)
    bubble.appendChild(inner)

    return bubble
  },

  formattedText(text) {
    const fragment = document.createDocumentFragment()
    const lines = (text || "").split("\n")

    lines.forEach((line, lineIndex) => {
      const lineDiv = document.createElement("div")

      line
        .split(/(\*\*[^*]+\*\*)/)
        .filter(Boolean)
        .forEach((segment) => {
          if (segment.startsWith("**") && segment.endsWith("**")) {
            const bold = document.createElement("b")
            bold.textContent = segment.slice(2, -2)
            lineDiv.appendChild(bold)
          } else {
            const span = document.createElement("span")
            span.textContent = segment
            lineDiv.appendChild(span)
          }
        })

      if (lineIndex < lines.length - 1) {
        lineDiv.appendChild(document.createElement("br"))
      }

      fragment.appendChild(lineDiv)
    })

    return fragment
  },

  formatTimestamp(value) {
    if (!value) return "agora"

    const date = value instanceof Date ? value : new Date(value)
    const day = date.getDate()
    const monthFormatter = new Intl.DateTimeFormat("pt-BR", {
      month: "long"
    })
    const month = monthFormatter.format(date)
    const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1)

    const timeFormatter = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    })
    const time = timeFormatter.format(date)

    return `${day} de ${monthCapitalized}, ${time}`
  },
})